import { render } from "./recipient_list.vue?vue&type=template&id=60913bb1"
import script from "./recipient_list.vue?vue&type=script&lang=js"
export * from "./recipient_list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__